import { render, staticRenderFns } from "./ContratosTablaActions.vue?vue&type=template&id=f06c4738&scoped=true"
import script from "./ContratosTablaActions.vue?vue&type=script&lang=js"
export * from "./ContratosTablaActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06c4738",
  null
  
)

export default component.exports